// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-tree-node[data-v-94789774] {\n    flex: 1;\n    display: flex;\n    align-items: left;\n    justify-content: space-between;\n    font-size: 14px;\n    padding-right: 8px;\n}\n.p-m[data-v-94789774] {\n    padding: 10px;\n}\n.p-l-m[data-v-94789774]{\n    padding-left: 10px;\n}\n.hide[data-v-94789774] {\n    display: none\n}\n", ""]);
// Exports
module.exports = exports;
